import styled from "styled-components";
import { Table } from 'react-bootstrap';

export const BreakdownWrapper = styled(Table)`
    border-collapse: collapse;

    & > thead > tr > th {
        background-color: #ddd;
        border: 1px solid #000 !important;
    }

    & > thead > tr > th, 
    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    & > tbody > tr > td.rowLabel {
        font-weight: bold;
    }

    & > tbody > tr > td.rowLabel.set-height {
        height: 36px;
    }

    .breakdown-label {
        background-color: #777;
        color: white;
        border-radius: 4px;
    }
`;